export default {
  'portal.error.automy.title': 'No pudimos completar el regreso automático a AUTOMY.',
  'portal.error.auth.title': 'No pudimos completar el cambio al portal automáticamente.',
  'portal.error.permission.title': 'Sin permiso para este portal',
  'portal.error.permission': 'No tienes permiso para entrar a este portal. Pide acceso o elige otra cuenta.',
  'portal.error.description': `Por favor, vuelve a iniciar sesión para continuar. Esto nos ayuda a mantener tu información segura y garantizar que todo funcione correctamente.`,
};
